import { Burger } from '@lt/components/icons-react';
import { WishlistHeart } from '@lt/components/icons-react/sidebar';
import { OnboardingArrow } from '@lt/components/icons-react/wishlist';
import { useTranslation } from '@lt/localization';
import React, { useRef } from 'react';
import styled from 'styled-components';
import { useOnClickOutside } from 'usehooks-ts';

type Props = {
  isOnboardingShowed?: boolean;
  hideOnboarding: () => void;
  openSidebar: () => void;
  isShiftedWishlistOnboarding: boolean;
  isMobile: boolean;
};

const WishlistOnboarding = (props: Props) => {
  const {
    isOnboardingShowed,
    hideOnboarding,
    openSidebar,
    isShiftedWishlistOnboarding,
    isMobile,
  } = props;

  const { t } = useTranslation();
  const title = t('wishlist.title', { ns: 'wishlist' });
  const additionalText = t('wishlist.onboarding.text', { ns: 'wishlist' });
  const buttonText = t('wishlist.onboarding.great', { ns: 'wishlist' });

  const onClick = () => {
    hideOnboarding();
  };
  const onBurgerClicked = () => {
    hideOnboarding();
    openSidebar();
  };
  const onboardingRef = useRef<HTMLDivElement>(null);
  useOnClickOutside(onboardingRef, hideOnboarding);
  if (!isOnboardingShowed || !isMobile) return null;
  return (
    <StyledContainer
      ref={onboardingRef}
      $isShifted={isShiftedWishlistOnboarding}
    >
      <StyledContent>
        <Burger width={24} onClick={onBurgerClicked} />
        <StyledIconWithTitle>
          <StyledWishlistHeart />
          {title}
        </StyledIconWithTitle>
        <StyledMoreText>{additionalText}</StyledMoreText>
        <StyledButton onClick={onClick}>{buttonText}</StyledButton>
        <StyledArrow />
      </StyledContent>
    </StyledContainer>
  );
};

const StyledContainer = styled.div<{ $isShifted?: boolean }>`
  position: fixed;
  z-index: 1001;
  top: ${({ $isShifted }) => ($isShifted ? `-60px` : `-120px`)};
  right: -156px;
  width: 379px;
  height: 379px;
  border-radius: 379px;
  background: #1c9ee3;
  color: white;
`;

const StyledContent = styled.div`
  position: relative;
  left: 66px;
  top: 158px;
  width: 150px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`;
const StyledIconWithTitle = styled.div`
  display: inline-flex;
  gap: 6px;
  align-items: center;
  font-size: 14px;
  margin-top: 26px;
  position: relative;
`;

const StyledArrow = styled(OnboardingArrow)`
  top: 8px;
  position: absolute;
  width: 40px;
  height: 26px;
  right: 32px;
`;

const StyledWishlistHeart = styled(WishlistHeart)`
  width: 20px;
  & > path {
    fill: white;
  }
`;

const StyledMoreText = styled.div`
  text-align: right;
  line-height: 16px;
  margin-top: 8px;
`;

const StyledButton = styled.div`
  border-radius: 5px;
  border: 1px solid rgba(255, 255, 255, 0.7);
  height: 32px;
  padding: 2px 12px;
  margin-top: 8px;
  display: inline-flex;
  align-items: center;
`;

export default WishlistOnboarding;
